import { render, staticRenderFns } from "./StudentDetail.vue?vue&type=template&id=4ed79bb0&scoped=true&"
import script from "./StudentDetail.vue?vue&type=script&lang=js&"
export * from "./StudentDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudentDetail.vue?vue&type=style&index=0&id=4ed79bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed79bb0",
  null
  
)

export default component.exports